module.exports = __webpack_public_path__ + "templates/customer-fields.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-account/templates/customer-fields.html
// module id = 85Z3
// module chunks = 1